import React from 'react';
import {Box, Typography} from '@mui/material';
import DynamicProgressBar from '../../../../components/progressBars/dynamicProgressBar';

export const ProgressIndicator = ({
  value,
  size = 80,
  thickness = 8,
  color = '#35C6C9',
  showValue = true,
  blurred = false,
}) => {
  return (
    <Box position="relative" display="inline-flex">
      <DynamicProgressBar
        paramValue={blurred ? 100 : Number(Math.round(value))}
        paramSize={size}
        paramThickness={thickness}
        barColor={blurred ? '#D9D9D9' : color}
      />
      {showValue && (
        <Typography
          variant="h6"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          sx={{
            fontWeight: 'bold',
            filter: blurred ? 'blur(6px)' : 'blur(0px)',
          }}
        >
          {Math.round(value)}
        </Typography>
      )}
    </Box>
  );
};
